/**
 * Minimalerei Variant-Pills Custom Element
 *
 * Analog zum <minimalerei-material-picker>: Pill-Buttons sind UI-
 * Overlay über versteckten Dawn-Radios in <variant-selects>. Klick
 * findet den passenden Radio, setzt checked, dispatched 'change'.
 * Dawn's <variant-selects>-Listener publisht optionValueSelectionChange
 * → product-info.js fetcht aktualisiertes Section-HTML → alle Blocks
 * re-rendern (inkl. Pill-Gruppe mit neuem aktiven Wert + Disabled-
 * States aus Liquid via value.selected / value.available).
 *
 * Kein eigener Pub-Sub-Subscribe nötig — der Section-Reload reicht.
 * Pill-Active/Disabled-States kommen direkt aus Liquid bei jeder
 * Re-Render. JS-Updates der Klassen sind nur für instant-feedback
 * während der Section-Fetch läuft (~200-500ms).
 */

class MinimalereiVariantPills extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.pills = Array.from(this.querySelectorAll('[data-pill]'));
    if (this.pills.length === 0) return;

    this.radioName = this.dataset.radioName;
    this.currentEl = this.querySelector('[data-current-value]');

    this.bindEvents();
  }

  bindEvents() {
    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.handlePillClick(pill));
    });
  }

  handlePillClick(pill) {
    if (pill.disabled || pill.classList.contains('is-disabled')) return;

    const value = pill.dataset.value;
    if (!value || !this.radioName) return;

    // Versteckten Dawn-Radio finden und triggern.
    const radio = document.querySelector(
      `input[type="radio"][name="${CSS.escape(this.radioName)}"][value="${CSS.escape(value)}"]`
    );

    if (radio) {
      radio.checked = true;
      // Bubbled change-Event lässt Dawn's <variant-selects> pub-sub
      // optionValueSelectionChange publishen → product-info.js
      // reloadet die Section.
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Instant Visual-Feedback während Section-Reload läuft.
    this.pills.forEach((p) => {
      const isActive = p === pill;
      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-pressed', String(isActive));
    });

    if (this.currentEl) {
      this.currentEl.textContent = value;
    }
  }
}

if (!customElements.get('minimalerei-variant-pills')) {
  customElements.define('minimalerei-variant-pills', MinimalereiVariantPills);
}
